import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type CopilotMode = 'sidebar' | 'floating' | 'fullscreen';

type LayoutState = {
  isCopilotVisible: boolean;
  copilotMode: CopilotMode;
  actions: {
    openCopilot: () => void;
    toggleCopilotVisibility: () => void;
    changeCopilotMode: (mode: CopilotMode) => void;
  };
};

const useLayoutStore = create<LayoutState>()(
  persist(
    (set) => ({
      isCopilotVisible: false,
      copilotMode: 'sidebar',
      actions: {
        openCopilot: () => set({ isCopilotVisible: true }),
        toggleCopilotVisibility: () =>
          set((state) => ({ isCopilotVisible: !state.isCopilotVisible })),
        changeCopilotMode: (mode: CopilotMode) => set({ copilotMode: mode }),
      },
    }),
    {
      name: 'layout',
      partialize: (state) => ({
        isCopilotVisible: state.isCopilotVisible,
        copilotMode: state.copilotMode,
      }),
    },
  ),
);

export const useIsCopilotVisible = () =>
  useLayoutStore((state) => state.isCopilotVisible);

export const useLayoutActions = () => useLayoutStore((state) => state.actions);
